
<!--Top Menu Desktop-->
<ng-container *ngIf="this.toggleMenu == 2">
  <div class="top-menu" id="top-menu" [ngClass]="{'complete': this.completeMenu}">
    <div class="menu-container">
        <div class="search-bar-input" >
          <div class="div-input">
            <div class="icon-search"></div>
            <input class="desktop" [(ngModel)]="filter" (ngModelChange)="this.changeInput()" type="text" placeholder="Pesquise um produto" #inputDesktop>
            <div class="clear-searsh" *ngIf="this.filter.length > 0" (click)="clearFilter()">
              <i class="fa-solid fa-x cancel-input"></i>
            </div>
          </div>
        </div>
        <div class="menu-top-buttons" *ngIf="!this.readOnlyState && this.company" style="font-size: 20px;">
            <a class="btn" type="button" [routerLink]="['/', this.nameCompany, 'carrinho']" routerLinkActive="active"><i class="icon-shopping-cart" style="font-size: 20px;" aria-hidden="true"></i><span>Carrinho</span><span *ngIf="this.counterCart > 0" class="icon-quantity">{{ counterCart }}</span></a>
            <a [routerLink]="['/', this.nameCompany, 'consumption']" *ngIf="this.local" routerLinkActive="active"><i class="icon-book-open-text" style="text-align: center;"></i><span>Consumo</span></a>
            <a [routerLink]="['/', this.nameCompany, 'pedidos']" *ngIf="this.userConfirmation && !this.local" routerLinkActive="active"><i class="icon-book-open-text" style="text-align: center;"></i><span>Pedidos</span></a>
            <a [routerLink]="['/', this.nameCompany, 'user']" *ngIf="!this.local" routerLinkActive="active"><i class="icon-user" style="text-align: center;"></i><span>Perfil</span></a>
        </div>
    </div>
  </div>
</ng-container>

<!--Top mobile-->
<ng-container *ngIf="this.toggleMenu == 1 && this.company">
  <div style="display: flex;">
    <div class="background" [ngStyle]="{'background-image': this.backgroundLoad ? 'url(' + this.imgBackground + ')' : 'none'}" [ngClass]="{'loaded': this.backgroundLoad}"></div>
    <div class="box">
      <div class="box-info-company" [ngClass]="{'local': this.local, 'readOnly': this.readOnlyState}">
        <div class="img-logo" (click)="openInfoCompany = true;" >
          <img (load)="loadLogo()" [src]="this.img" [ngClass]="{'loaded': this.loadLogo}"/>
        </div> 
        <div class="content-company">
          <span class="name-company">{{ this.company.company.companyName }}</span>

          <ng-container *ngIf="!this.readOnlyState">

            <!--Loja temporariamente fechada-->
            <span *ngIf="!this.local && this.statusCompany && this.company.companyHours.online == 0" class="open-company" style="color: #bf7c00; background-color: #ffa5004d;">Loja temporariamente fechada</span>

            <!--Loja aberta-->
            <span *ngIf="!this.local && this.statusCompany && this.company.companyHours.online == 1" class="open-company" style="color: green; background-color: #0080002b; margin-top: 6px;">{{ textStatusCompany }}</span>

            <!--Loja fechada-->
            <span *ngIf="!this.local && !this.statusCompany" class="open-company" style="color: #d70000; background-color: #ff000040;">{{ textStatusCompany }}</span>

            <!--Disponível para agendamento-->
            <span *ngIf="!this.local && this.company.configs.closeScheduling == 1" class="open-company" style="color: green; background-color: #0080002b; margin-top: 6px;">Disponível para agendamento</span>
            
          </ng-container>

          <div class="info-place-counter">
            <span>{{ this.placeCounter.placeName }}</span>
          </div>

          <!--Visivel se não estiver em modo Readonly-->
          <ng-container *ngIf="!this.readOnlyState">

            <!--Visivel se não for mesa ou comanda-->
            <div class="infos" *ngIf="!this.local">

              <!--Pedido Minimo-->
              <div class="info-chip" *ngIf="this.company.configs.minValue != 0">
                <span class="chip-label">Mínimo</span>
                <span class="chip-value">{{ this.company.configs.minValue | currency: 'BRL' }}</span>
              </div>
              
              <!--Status da loja-->
              <div class="info-chip" *ngIf="!this.statusCompany && this.company.companyHours.nextOpenHour">
                <span class="chip-label">Abre às</span>
                <span class="chip-value">{{ this.company.companyHours.nextOpenHour | timeFormat }}</span>
              </div>

              
              <div class="info-chip" *ngIf="this.statusCompany && this.company.companyHours.dataClose">
                <span class="chip-label">Fecha às</span>
                <span class="chip-value">{{ this.company.companyHours.dataClose | timeFormat }}</span>
              </div>

              <!--Tempo de preparo Delivery-->
              <ng-container *ngIf="!this.localCounter">
                <div class="info-chip" *ngIf="this.timesInfo.delivery.active">
                  <span class="chip-label">Entrega</span>
                  <span class="chip-value">{{ this.timesInfo.delivery.label }}</span>
                </div>
              </ng-container>

              <!--Tempo de preparo Balcão-->
              <ng-container *ngIf="this.localCounter">
                <div class="info-chip" *ngIf="this.timesInfo.counter.active">
                  <span class="chip-label">Retirada</span>
                  <span class="chip-value">{{ this.timesInfo.counter.label }}</span>
                </div>
              </ng-container>

            </div>

            <!--Avisos e Comunicados-->
            <app-banners style="width: 100%;"></app-banners>
            
            <!--Cashback-->
            <div class="cashback-wrapper" *ngIf="!this.local && this.company.configs.cashback == 1 && (this.company.configs.typeCashback == 1 || this.company.configs.typeCashback == 2)">
              <div class="cashback-badge" (click)="toggleRules()">
                 <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="8" r="6"/><path d="M18.09 10.37A6 6 0 1 1 10.34 18"/><path d="M7 6h1v4"/><path d="m16.71 13.88.7.71-2.82 2.82"/></svg>
                 <span *ngIf="this.company.configs.typeValue == 1">Ganhe {{ this.company.configs.value }}% de cashback</span>
                 <span *ngIf="this.company.configs.typeValue == 2">Ganhe {{ this.company.configs.value | currency: 'BRL' }} de cashback</span>
              </div>
            </div>

            <div *ngIf="this.local">
              <span style="font-weight: 600; color: var(--primary-color);" *ngIf="this.typeParam.type == 1">MESA {{ this.typeParam.numberParam }}</span>
              <span style="font-weight: 600; color: var(--primary-color);" *ngIf="this.typeParam.type == 2">COMANDA {{ this.typeParam.numberParam }}</span>
            </div>
            
          </ng-container>

        </div>

        <!--Input de pesquisa-->
        <div class="box-input-mobile" [ngClass]="{'fixed': this.fixed && this.filter != '' || this.fixed && this.activeInput}">
          <i class="icon-search"></i>
          <input class="input-mobile" [(ngModel)]="filter" (ngModelChange)="this.changeInput()" type="text" #input placeholder="Pesquise um produto"/>
          <div class="clear-searsh-mobile" [ngClass]="{'fixed-clear': this.fixed}" style="right: 18px;" *ngIf="this.filter.length > 0" (click)="clearFilter()">
            <i class="fa-solid fa-x cancel-input"></i>
          </div>
          <button (click)="closeInput()" class="button-cancel" *ngIf="this.fixed">Cancelar</button>
        </div>

        <div style="height: 55px; width: 100%;" *ngIf="this.fixed && this.filter != '' || this.fixed && this.activeInput"></div>

        <div class="icons-info" style="left: 13px;" (click)="openInfoCompany = true">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-info-icon lucide-info"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>
        </div>
        <div class="icons-info" style="right: 15px;" (click)="share()">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-share2-icon lucide-share-2"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" x2="15.42" y1="13.51" y2="17.49"/><line x1="15.41" x2="8.59" y1="6.51" y2="10.49"/></svg>
        </div>
      </div>

    </div>
  </div>

</ng-container>

<ng-container *ngIf="showRules">
    <app-rules-cashback (closeCanvas)="toggleRules()" [company]="company"></app-rules-cashback>
</ng-container>

<app-info-company [openInfo]="this.openInfoCompany" (closeInfo)="this.openInfoCompany = false; this.scrollService.enableScroll()"></app-info-company>
